import { render, staticRenderFns } from "./moneyinput.vue?vue&type=template&id=355e7b2f&scoped=true"
import script from "./moneyinput.vue?vue&type=script&lang=js"
export * from "./moneyinput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e7b2f",
  null
  
)

export default component.exports